import { render, staticRenderFns } from "./editColorTheme.vue?vue&type=template&id=6b262694&scoped=true"
import script from "./editColorTheme.vue?vue&type=script&lang=js"
export * from "./editColorTheme.vue?vue&type=script&lang=js"
import style0 from "./editColorTheme.vue?vue&type=style&index=0&id=6b262694&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b262694",
  null
  
)

export default component.exports